(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oztra-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('oz-hero')) {
    customElements.define(
      'oz-hero',
      class extends HTMLElement {
        connectedCallback() {
          const fine = window.matchMedia('(pointer: fine)').matches;
          const still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          if (!fine || still) return;
          let frame = 0;
          this.onMove = (event) => {
            if (frame) return;
            frame = requestAnimationFrame(() => {
              const box = this.getBoundingClientRect();
              this.style.setProperty('--mx', `${event.clientX - box.left}px`);
              this.style.setProperty('--my', `${event.clientY - box.top}px`);
              this.classList.add('is-lit');
              frame = 0;
            });
          };
          this.onLeave = () => this.classList.remove('is-lit');
          this.addEventListener('pointermove', this.onMove);
          this.addEventListener('pointerleave', this.onLeave);
        }
        disconnectedCallback() {
          this.removeEventListener('pointermove', this.onMove);
          this.removeEventListener('pointerleave', this.onLeave);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oztra-popup"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('oz-popup')) {
    customElements.define(
      'oz-popup',
      class extends HTMLElement {
        connectedCallback() {
          this.dialog = this.querySelector('dialog');
          const key = 'oz-popup-dismissed';
          const read = () => {
            try {
              return localStorage.getItem(key);
            } catch (e) {
              return null;
            }
          };
          const write = () => {
            try {
              localStorage.setItem(key, String(Date.now()));
            } catch (e) {}
          };
          this.querySelectorAll('[data-close]').forEach((b) =>
            b.addEventListener('click', () => {
              write();
              this.dialog.close();
            })
          );
          this.dialog.addEventListener('click', (e) => {
            if (e.target === this.dialog) {
              write();
              this.dialog.close();
            }
          });
          this.dialog.addEventListener('cancel', write);
          if (this.querySelector('[data-success]') || this.querySelector('.oz-popup__error')) {
            write();
            this.dialog.showModal();
            return;
          }
          if (window.Shopify && window.Shopify.designMode) return;
          const last = Number(read() || 0);
          if (Date.now() - last < 1000 * 60 * 60 * 24 * 14) return;
          this.timer = setTimeout(() => this.dialog.showModal(), Number(this.dataset.delay || 8) * 1000);
        }
        disconnectedCallback() {
          clearTimeout(this.timer);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oztra-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('oz-tabs')) {
    customElements.define(
      'oz-tabs',
      class extends HTMLElement {
        connectedCallback() {
          this.tabs = [...this.querySelectorAll('[role="tab"]')];
          this.tabs.forEach((tab, i) => {
            tab.addEventListener('click', () => this.select(i));
            tab.addEventListener('keydown', (e) => {
              const step = { ArrowRight: 1, ArrowLeft: -1 }[e.key];
              if (!step) return;
              e.preventDefault();
              const next = (i + step + this.tabs.length) % this.tabs.length;
              this.select(next);
              this.tabs[next].focus();
            });
          });
        }
        select(index) {
          this.tabs.forEach((tab, i) => {
            const on = i === index;
            tab.setAttribute('aria-selected', String(on));
            tab.tabIndex = on ? 0 : -1;
            const panel = this.querySelector(`#${tab.getAttribute('aria-controls')}`);
            if (panel) panel.hidden = !on;
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
